<script lang="ts">
  import {
    patronMenuDrawerOpen,
    keyboardMode,
    colors,
    focusContent,
    scrollDisabled,
    activeColor,
  } from "$lib/data";
  import { page } from "$app/stores";
  import { fade, fly } from "svelte/transition";
  import Logo from "$lib/components/layout/header/Logo.svelte";

  let height: number;

  // keyboard navigation control
  let logoLink: HTMLElement;
  import { onMount } from "svelte";
  import Sidebar from "$components/dashboard/Sidebar.svelte";
  import { browser } from "$app/environment";
  import DisplayName from "$components/profile/DisplayName.svelte";
  import Avatar from "$components/profile/Avatar.svelte";

  const endMenu = () => {
    if (!browser) return;
    $patronMenuDrawerOpen = false;
    $focusContent = true;
    setTimeout(() => {
      $focusContent = false;
    }, 1000);
  };

  onMount(() => {
    if ($patronMenuDrawerOpen && $keyboardMode) {
      logoLink.focus();
    }
  });
</script>

<svelte:window bind:innerHeight={height} />
<div
  class="mobileMenu"
  on:click={() => ($patronMenuDrawerOpen = false)}
  on:click={() => ($scrollDisabled = false)}
  on:keypress={() => ($patronMenuDrawerOpen = false)}
  on:keypress={() => ($scrollDisabled = false)}
  in:fade={{ duration: 200 }}
  out:fade={{ duration: 200 }}
  role="button"
  aria-pressed="false"
  tabindex="-1"
>
  <nav
    in:fly={{ duration: 400, x: 200 }}
    out:fly={{ duration: 400, x: 200 }}
    style:height="calc({height + "px"} - 5rem})"
  >
    {#if $keyboardMode}
      <header class:noKeys={!$keyboardMode}>
        <div>
          <button
            on:click={() => ($patronMenuDrawerOpen = false)}
            aria-label="Close navigation menu"
          >
            <svg
              fill="none"
              viewBox="0 0 24 24"
              height="24"
              width="24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                xmlns="http://www.w3.org/2000/svg"
                d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z"
              />
            </svg>
          </button>
        </div>
        {#if $page.data.user}
          <div class="user">
            <a href="/">
              <span class="title">
                <DisplayName user={$page.data.user} />
              </span>
              <div class="avatar">
                <Avatar user={$page.data.user} />
              </div>
            </a>
          </div>
        {:else}
          <a
            rel="external"
            on:click={() => {
              $patronMenuDrawerOpen = false;
            }}
            href="/login"
            class="login_button"
            style="
                            --primary: {colors[$activeColor].color};
                            --secondary: {colors[$activeColor].highlight};
                        "
          >
            Patron Login
          </a>
        {/if}
      </header>

      <a href="/" class="logo" bind:this={logoLink}>
        <Logo />
      </a>
    {/if}
    <Sidebar mobile_pad />
    {#if $keyboardMode}
      <a
        style:text-decoration="none"
        style:font-weight="normal"
        href="/"
        on:click|preventDefault={endMenu}
        on:focus={endMenu}
      >
        <small>
          <kbd>CTRL</kbd> + <kbd>M</kbd> MENU TOGGLE
        </small>
        <small>
          <kbd>CTRL</kbd> + <kbd>,</kbd> FOCUS CONTENT
        </small>
      </a>
    {/if}
  </nav>
</div>

<style>
.title {
  color: var(--title);
  display: inline-flex;
  gap: 0.15rem;
}

.login_button {
  margin-left: 1.5rem;
  text-decoration: none;
  font-size: 1rem;
  color: white;
  background: var(--secondary);
  display: inline-flex;
  padding: 0.6rem 1.1rem;
  border-radius: 0.7rem;
  position: relative;
  overflow: hidden;
}
.login_button:hover {
  background: var(--primary);
}

.mobileMenu {
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 10;
  color: white;
  background: hsla(207, 18%, 15%, 0.95);
  box-sizing: border-box;
  height: calc(100vh - 5rem);
}
.mobileMenu .logo {
  margin: 1rem;
  display: flex;
  align-items: center;
  font-family: Bitter;
  text-decoration: none;
  font-weight: bold;
  font-size: 1.7rem;
}
.mobileMenu header {
  border-bottom: 1px solid var(--dots);
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  position: sticky;
  top: 0;
  background: white;
}
.mobileMenu header .user {
  overflow: hidden;
}
.mobileMenu header .user a {
  word-break: break-all;
  font-size: 0.75rem;
  text-decoration: none;
  display: flex;
  flex-flow: row;
  align-items: center;
  gap: 0.5rem;
  color: var(--title);
}
.mobileMenu header .user .avatar {
  width: 40px;
  height: 40px;
}
.mobileMenu header button {
  border: none;
  display: inline-grid;
  place-content: center;
  width: 40px;
  height: 40px;
  border: 1px solid var(--dots);
  background: white;
  border-radius: 0.25rem;
}
.mobileMenu header button svg {
  width: 24px;
  height: 24px;
  color: var(--title);
}
.mobileMenu header button svg path {
  fill: var(--title);
}
.mobileMenu nav {
  background: white;
  position: absolute;
  right: 0;
  height: calc(100vh - 5rem);
  overflow-y: auto;
  width: 370px;
  max-width: 100%;
  box-shadow: var(--shadow);
}
</style>
